import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormHelperText,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useState } from "react";
import styles from "./PaymentType/PaymentType.module.css";
import {
  recordPaymentForConversion,
  resetConversionSuccess,
  resetSendLinkAndRecordPaymentConversion,
  sendPaymentLinkForConversion,
} from "../service/nurtureSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useAuthUser } from "react-auth-kit";
import moment from "moment";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { toggleTriggerForNurture } from "../../Main/service/submerchantBranchUpdationSlice";
import { findBranchById } from "../../../../components/CommonFunctions/CommonFunctions";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "95%",
    sm: "50%",
    lg: 430,
    xl: 430,
    md: 430,
  },
  bgcolor: "background.paper",
  border: "none",
  boxShadow:
    "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
  borderRadius: "12px",
  p: "20px",
  // zIndex: 999999,
};

const PaymentPopupFromConversion = ({
  openConversionPaymentPopup,
  setOpenConversionPaymentPopup,
  draggedLeadInfo,
  List,
}: any) => {
  const [total, setTotal] = useState<string>("");
  const [amount, setAmount] = useState<any>("");
  const [amountError, setAmountError] = useState<boolean>(false);
  const [paymentNameError, setPaymentNameError] = useState<boolean>(false);
  const dispatch = useDispatch();
  const leadStatusUpdateData = useSelector(
    (state: any) => state.nurture.leadStatusUpdateData
  );
  const [paymentSource, setPaymentSource] = useState<string>("");
  const [paymentSourceError, setPaymentSourceError] = useState<string>("");
  const [showRecordButton, setShowRecordButton] = useState(false);
  const [paymentLinkDetails, setPaymentLinkDetails] = React.useState<any>({
    leadId: "",
    contact: "",
    emiId: "",
    paymentType: "",
    amount: 0,
    subMerchantId: "",
    module: "",
    email: "",
  });
  const auth = useAuthUser();
  const authUser = auth();
  const [paymentDetails, setPaymentDetails] = React.useState({
    enquiryId: "",
    basePrice: "",
    discountMetric: "",
    discount: 0,
    amountReceived: 0,
    balance: 0,
    description: "",
    gstNumber: "",
    gstCompanyDetails: "",
    paymentDate: "",
    isFirstPayment: true,
    paymentSource: "",
    createdByName:
      authUser?.institute[0]?.firstName +
      " " +
      authUser?.institute[0]?.lastName,
    createdById: authUser?.institute[0]?.id,
    sendReceipt: false,
  });
  const [endDate, setEndDate] = React.useState<any>(null);
  const [endDateError, setEndDateError] = React.useState<string>("");
  const [endDateForCal, setEndDateForCal] = React.useState<any>(null);
  const [showCalendar, setShowCalendar] = useState(false);

  const instituteData = useSelector(
    (state: any) => state.institute.instituteDetails
  );
  const {
    sendPaymentForConversionSuccess,
    sendPaymentForConversionLoading,
    recordPaymentForConversionSuccess,
    recordPaymentForConversionLoading,
  } = useSelector((state: any) => state.nurture);

  const hasNurturePay =
    instituteData &&
    Array.isArray(instituteData.integrationsOpted) &&
    instituteData?.integrationsOpted?.includes("NURTURE_PAY_EASEBUZZ");

  const closePaymentLinkPopup = () => {
    setOpenConversionPaymentPopup(false);
    dispatch(resetConversionSuccess());
    dispatch(resetSendLinkAndRecordPaymentConversion());
  };

  const handleNameChange = React.useCallback((value: any) => {
    setTotal(value);
    if (value) {
      setPaymentNameError(false);
    } else {
      setPaymentNameError(true);
    }
  }, []);

  const handleAmount = React.useCallback((value: any) => {
    setAmount(value);
    if (parseFloat(value) > 0) {
      setAmountError(false);
    } else {
      setAmountError(true);
    }

    if (amount < 0) {
      setAmountError(true);
    } else if (
      (leadStatusUpdateData?.data?.enquiryData?.paymentDetails?.paymentType ===
        "REGULAR" ||
        leadStatusUpdateData?.data?.enquiryData?.paymentDetails?.paymentType ===
          "MEMBERSHIP") &&
      parseFloat(value) > leadStatusUpdateData?.data?.enquiryData?.balanceAmount
    ) {
      setAmountError(true);
    } else {
      setAmountError(false);
    }
  }, []);

  React.useEffect(() => {
    if (leadStatusUpdateData) {
      const upcomingInstallment = leadStatusUpdateData?.data?.emiData?.find(
        (item: any) =>
          item.paymentStatus === "OVERDUE" || item.paymentStatus === "UPCOMING"
      );
      const emiId = leadStatusUpdateData?.data?.emiData?.find(
        (d: any) => d?.id === upcomingInstallment?.id
      );
      setPaymentLinkDetails({
        ...paymentLinkDetails,
        leadId: leadStatusUpdateData?.data?.enquiryData?.id,
        contact: leadStatusUpdateData?.data?.enquiryData?.studentContact,
        emiId:
          leadStatusUpdateData?.data?.emiData?.length === 0 ? "" : emiId?.id,
        paymentType:
          leadStatusUpdateData?.data?.enquiryData?.paymentDetails?.paymentType,
        amount: amount,
        subMerchantId: "",
        module: "ENQUIRY",
        email: leadStatusUpdateData?.data?.enquiryData?.studentEmail,
        actionToPerform: hasNurturePay
          ? "SEND_PAYMENT_LINK"
          : "SEND_REMAINDER_EMAIL",
      });

      const remainingEmiAmount = leadStatusUpdateData?.data?.emiData
        ?.filter(
          (item: any) =>
            item?.paymentStatus === "OVERDUE" ||
            item?.paymentStatus === "UPCOMING"
        )
        ?.reduce((total: any, item: any) => {
          return total + Number(item.emiAmount);
        }, 0);

      const balanceAmount: any =
        leadStatusUpdateData?.data?.enquiryData?.paymentDetails?.paymentType ===
        "MEMBERSHIP"
          ? remainingEmiAmount
          : parseFloat(
              (
                leadStatusUpdateData?.data?.enquiryData?.balanceAmount - amount
              ).toFixed(2)
            );

      setPaymentDetails({
        ...paymentDetails,
        enquiryId: leadStatusUpdateData?.data?.enquiryData?.id,
        basePrice:
          leadStatusUpdateData?.data?.enquiryData?.paymentDetails?.finalAmount,
        balance: balanceAmount,
        isFirstPayment: true,
      });
    }
  }, [leadStatusUpdateData]);

  useEffect(() => {
    if (
      leadStatusUpdateData?.data?.enquiryData?.paymentDetails?.paymentType ===
        "REGULAR" &&
      leadStatusUpdateData?.data?.emiData?.length === 0
    ) {
      setTotal(leadStatusUpdateData?.data?.enquiryData?.balanceAmount);
      setAmount(leadStatusUpdateData?.data?.enquiryData?.balanceAmount);
    } else if (
      (leadStatusUpdateData?.data?.enquiryData?.paymentDetails?.paymentType ===
        "REGULAR" ||
        leadStatusUpdateData?.data?.enquiryData?.paymentDetails?.paymentType ===
          "MEMBERSHIP") &&
      leadStatusUpdateData?.data?.emiData?.length > 0
    ) {
      const upcomingInstallment = leadStatusUpdateData?.data?.emiData?.find(
        (item: any) =>
          item.paymentStatus === "OVERDUE" || item.paymentStatus === "UPCOMING"
      );
      const emiId = leadStatusUpdateData?.data?.emiData?.find(
        (d: any) => d?.id === upcomingInstallment?.id
      );
      setTotal(
        leadStatusUpdateData?.data?.enquiryData?.paymentDetails?.paymentType ===
          "MEMBERSHIP"
          ? emiId?.emiAmount
          : leadStatusUpdateData?.data?.enquiryData?.balanceAmount
      );
      setAmount(emiId?.emiAmount);
    }
  }, [leadStatusUpdateData]);

  const handleChangePaymentSource = React.useCallback((event: any) => {
    setPaymentSource(event.target.value);
    setPaymentSourceError("");
  }, []);

  const handleSendPayment = async () => {
    try {
      dispatch<any>(
        sendPaymentLinkForConversion({
          ...paymentLinkDetails,
          amount: amount,
          actionToPerform:
            (hasNurturePay &&
              subMerchangeInfo?.subMerchantAdded === true &&
              subMerchangeInfo?.subMerchantId !== "" &&
              paymentLinkDetails?.contact?.startsWith("91")) ||
            (hasNurturePay &&
              subMerchangeInfo?.partnerKey &&
              subMerchangeInfo?.partnerSalt &&
              subMerchangeInfo?.keySaltAdded &&
              paymentLinkDetails?.contact)
              ? "SEND_PAYMENT_LINK"
              : "SEND_REMAINDER_EMAIL",
          paymentStatus: "REQUESTED",
          createdById: authUser?.institute?.[0]?.id,
          createdByName: authUser?.firstName + " " + authUser?.lastName,
          paymentByCart:
            hasNurturePay &&
            subMerchangeInfo?.keySaltAdded === true &&
            subMerchangeInfo?.country !== "India"
              ? true
              : false,
        })
      );
    } catch (error) {}
  };

  useEffect(() => {
    if (sendPaymentForConversionSuccess === true) {
      closePaymentLinkPopup();
    }
  }, [sendPaymentForConversionSuccess]);

  useEffect(() => {
    if (recordPaymentForConversionSuccess === true) {
      closePaymentLinkPopup();
    }
  }, [recordPaymentForConversionSuccess]);

  const handleRecordPayment = async () => {
    const currentTimestamp = moment().valueOf();

    const remainingEmiAmount = leadStatusUpdateData?.data?.emiData
      ?.filter(
        (item: any) =>
          item?.paymentStatus === "OVERDUE" ||
          item?.paymentStatus === "UPCOMING"
      )
      ?.reduce((total: any, item: any) => {
        return total + Number(item.emiAmount);
      }, 0);

    const balanceAmount: any =
      leadStatusUpdateData?.data?.enquiryData?.paymentDetails?.paymentType ===
      "MEMBERSHIP"
        ? remainingEmiAmount
        : parseFloat(
            (
              leadStatusUpdateData?.data?.enquiryData?.balanceAmount - amount
            ).toFixed(2)
          );

    const updatedPaymentDetails = {
      ...paymentDetails,
      amountReceived: amount,
      balance:
        leadStatusUpdateData?.data?.enquiryData?.paymentDetails?.paymentType ===
        "MEMBERSHIP"
          ? 0
          : balanceAmount?.toFixed(2),
      paymentDate: endDate,
      isOfflinePayment: true,
    };

    const upcomingInstallment = leadStatusUpdateData?.data?.emiData?.find(
      (item: any) =>
        item.paymentStatus === "OVERDUE" || item.paymentStatus === "UPCOMING"
    );
    const emiId = leadStatusUpdateData?.data?.emiData?.find(
      (d: any) => d?.id === upcomingInstallment?.id
    );

    try {
      await dispatch<any>(
        recordPaymentForConversion({
          ...updatedPaymentDetails,
          emiId: emiId?.id,
          paymentType:
            leadStatusUpdateData?.data?.enquiryData?.paymentDetails
              ?.paymentType,
          paymentStatus: "PAID",
        })
      );
      dispatch<any>(toggleTriggerForNurture(false));
    } catch (error) {
      // Handle the error
    }
  };

  const handleEndDateChange = React.useCallback((date: any) => {
    const dateUnix = date.unix() * 1000;
    setEndDateForCal(dateUnix);
    const selectedDate = moment(dateUnix);
    const now = moment();
    selectedDate.set({
      hour: now.hour(),
      minute: now.minute(),
      second: now.second(),
      millisecond: now.millisecond(),
    });
    const finalTimestamp = selectedDate.valueOf();
    setEndDate(finalTimestamp);
  }, []);

  const leadInfoFromLocalStorage: any = JSON.parse(
    localStorage.getItem("draggedInfo")!
  );
  const batchEndDateMilliSeconds = List
    ? leadInfoFromLocalStorage?.bacthEndDate?.toString()?.length !== 13
      ? leadInfoFromLocalStorage?.bacthEndDate * 1000
      : leadInfoFromLocalStorage?.bacthEndDate
    : draggedLeadInfo?.bacthEndDate?.toString()?.length !== 13
    ? draggedLeadInfo?.bacthEndDate * 1000
    : draggedLeadInfo?.bacthEndDate;

  const batchStartDateMilliSeconds = List
    ? leadInfoFromLocalStorage?.batchStartDate?.toString()?.length !== 13
      ? leadInfoFromLocalStorage?.batchStartDate * 1000
      : leadInfoFromLocalStorage?.batchStartDate
    : draggedLeadInfo?.batchStartDate?.toString()?.length !== 13
    ? draggedLeadInfo?.batchStartDate * 1000
    : draggedLeadInfo?.batchStartDate;

  const branches = useSelector((state: any) => state.branch.branchList);

  const subMerchangeInfo = findBranchById(draggedLeadInfo?.branchId, branches);
  console.log(subMerchangeInfo, draggedLeadInfo?.branchId);
  return (
    <Modal
      open={openConversionPaymentPopup}
      onClose={closePaymentLinkPopup}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      // sx={{ zIndex: "999999" }}
      sx={{ display: showCalendar ? 0 : 9999999 }}
    >
      <Box sx={style} style={{ padding: "20px" }}>
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div style={{ fontWeight: "500" }}>Send Payment Link</div>
            <div
              onClick={closePaymentLinkPopup}
              className={styles.closeModalButton}
            >
              <CloseIcon />
            </div>
          </div>
          <div>
            <div className={styles.customTypeFieldLabel}>Total Payment</div>
            <TextField
              id="total"
              variant="outlined"
              type="text"
              fullWidth
              inputProps={{
                sx: {
                  "&::placeholder": {
                    fontWeight: "400",
                    fontSize: "14px",
                  },

                  "&.MuiOutlinedInput-input": {
                    padding: "8px",
                  },
                },
              }}
              value={total}
              onChange={(event) => handleNameChange(event.target.value)}
              error={paymentNameError}
              disabled={true}
            />
          </div>
          <div>
            <div className={styles.customTypeFieldLabel}>
              Amount to be collected
            </div>

            <TextField
              id="price"
              variant="outlined"
              type="number"
              fullWidth
              inputProps={{
                sx: {
                  "&::placeholder": {
                    fontWeight: "400",
                    fontSize: "14px",
                  },

                  "&.MuiOutlinedInput-input": {
                    padding: "8px",
                  },
                },
              }}
              value={amount}
              onChange={(event) => handleAmount(event.target.value)}
              error={amountError}
              helperText={amountError ? "Please fill valid amount" : ""}
            />
          </div>
          {showRecordButton && (
            <>
              <FormControl sx={{ m: 1, margin: "6px 0", width: "100%" }}>
                <div className={styles.customTypeFieldLabel}>
                  Payment source <span style={{ color: "#EC3939" }}>*</span>
                </div>
                <Select
                  MenuProps={{
                    style: {
                      zIndex: 999999,
                      maxHeight: 400,
                    },
                    PaperProps: {
                      style: {
                        boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.06)",
                      },
                    },
                  }}
                  placeholder="Select"
                  variant="outlined"
                  id="paymentSource"
                  value={paymentSource}
                  onChange={handleChangePaymentSource}
                  error={!!paymentSourceError}
                  sx={{
                    "& .MuiOutlinedInput-input": {
                      padding: "10px 16px",
                    },
                  }}
                >
                  <MenuItem
                    sx={{
                      fontSize: "13PX",
                      color: "#18181B",
                    }}
                    value="Cash"
                  >
                    Cash
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontSize: "13PX",
                      color: "#18181B",
                    }}
                    value="POS"
                  >
                    POS
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontSize: "13PX",
                      color: "#18181B",
                    }}
                    value="UPI"
                  >
                    UPI
                  </MenuItem>
                  <MenuItem
                    sx={{
                      fontSize: "13PX",
                      color: "#18181B",
                    }}
                    value="Bank Transfer"
                  >
                    Bank Transfer
                  </MenuItem>
                </Select>
                {paymentSourceError && (
                  <FormHelperText error> {paymentSourceError}</FormHelperText>
                )}
              </FormControl>
              <FormControl
                sx={{
                  m: 1,
                  margin: "6px 0",
                  width: "100%",
                  zIndex: 999999,
                }}
              >
                <Typography
                  sx={{
                    color: "#142C44",
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "18px",
                    marginBottom: "6px",
                  }}
                >
                  Transaction date <span style={{ color: "#EC3939" }}>*</span>
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    sx={{
                      zIndex: "999999 !important",
                      width: "100%",
                      fontSize: "14px",
                      "& .MuiOutlinedInput-input": {
                        fontSize: "14px",
                        color: "#142C44",
                        padding: "9px",
                      },
                    }}
                    format="DD/MM/YYYY"
                    onChange={(date: any) => {
                      setEndDateForCal(date);
                      handleEndDateChange(date);
                    }}
                    value={endDateForCal ? dayjs(endDateForCal) : null}
                    minDate={dayjs(batchStartDateMilliSeconds)}
                    maxDate={dayjs(batchEndDateMilliSeconds).subtract(1, "day")}
                    onOpen={() => {
                      setShowCalendar(true);
                    }}
                    onClose={() => {
                      setShowCalendar(false);
                    }}
                  />
                </LocalizationProvider>
                {endDateError && (
                  <FormHelperText error> {endDateError}</FormHelperText>
                )}
              </FormControl>
            </>
          )}
          <div className={styles.leadRandomPayPopup}>
            <Button
              variant="outlined"
              type="reset"
              sx={{
                color: "#BFBFBF",
                borderColor: "#BFBFBF",
                textTransform: "capitalize",
                minWidth: "100px",
              }}
              onClick={() => {
                handleSendPayment();
              }}
              disabled={amountError || amount === ""}
            >
              {sendPaymentForConversionLoading ? (
                <CircularProgress size={20} color={"inherit"} />
              ) : (
                <>
                  {(hasNurturePay &&
                    subMerchangeInfo?.subMerchantAdded === true &&
                    subMerchangeInfo?.subMerchantId !== "" &&
                    paymentLinkDetails?.contact?.startsWith("91")) ||
                  (hasNurturePay &&
                    subMerchangeInfo?.partnerKey &&
                    subMerchangeInfo?.partnerSalt &&
                    subMerchangeInfo?.keySaltAdded &&
                    paymentLinkDetails?.contact)
                    ? "Send Payment Link"
                    : "Send Payment Reminder"}
                </>
              )}
            </Button>
            {showRecordButton === false && (
              <Button
                sx={{ textTransform: "capitalize", minWidth: "100px" }}
                variant="contained"
                onClick={() => {
                  setShowRecordButton(true);
                }}
                disabled={
                  amountError ||
                  paymentNameError ||
                  parseFloat(amount) <= 0 ||
                  total === "" ||
                  amount === ""
                }
              >
                Record Payment
              </Button>
            )}
            {showRecordButton && (
              <Button
                sx={{ textTransform: "capitalize", minWidth: "100px" }}
                variant="contained"
                onClick={() => {
                  handleRecordPayment();
                }}
                disabled={
                  amountError || paymentSource === "" || endDate === null
                }
              >
                {recordPaymentForConversionLoading ? (
                  <CircularProgress size={20} color={"inherit"} />
                ) : (
                  "Save"
                )}
              </Button>
            )}
          </div>
        </>
      </Box>
    </Modal>
  );
};

export default PaymentPopupFromConversion;
